// ----------------------------------------------------------------------

const account = {
  displayName: 'Super Admin',
  email: 'awin@mailinator.com',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
